define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
    url: '/delegate/civics-api/api/portal/users/forgotpassword',
  });
});
